import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorService {

  constructor() { }

  private _rgbToDecimal(rgb: [number, number, number]): [number, number, number] {
    const result = rgb.map((value) => {
      return value / 255;
    }) as [number, number, number];

    return result;
  }

  private _rgbFromDecimal(rgb: [number, number, number]): [number, number, number] {
    const result =  rgb.map((value) => {
      return Math.round(value * 255);
    }) as [number, number, number];

    return result;
  }

  hexToRgba(hex: string, asDecimal = false): [number, number, number, number] {
    // normalize hex
    hex = hex
      .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => [r, r, g, g, b, b].join('')) // #fff -> #ffffff
      .replace(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, (m, r, g, b) => [r, g, b, 'ff'].join('')); // #ffffff -> #ffffffff

    const regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex); // #ffffffff
    const red = parseInt(regex[1], 16);
    const green = parseInt(regex[2], 16);
    const blue = parseInt(regex[3], 16);
    const alpha = parseInt(regex[4], 16) / 255; // important: 0...1

    if (asDecimal) {
      const rgb = this._rgbToDecimal([red, green, blue]);
      return [rgb[0], rgb[1], rgb[2], alpha];
    } else {
      return [red, green, blue, alpha];
    }
  }

  hexToRgb(hex: string, asDecimal = false): [number, number, number] {
    const rgba = this.hexToRgba(hex, asDecimal);
    return [
      rgba[0],
      rgba[1],
      rgba[2]
    ];
  }

  rgbToHex(rgb: [number, number, number], isDecimal = false) {
    if (isDecimal) {
      return this.toHex(this._rgbFromDecimal(rgb));
    } else {
      return this.toHex(rgb);
    }
  }

  rgbaToHex(rgba: [number, number, number, number], isDecimal = false) {
    const red = rgba[0];
    const green = rgba[1];
    const blue = rgba[2];
    const alpha = rgba[3] * 255; // important: 0...1 -> 0...255
    if (isDecimal) {
      return this.toHex([...this._rgbFromDecimal([red, green, blue]), alpha]);
    } else {
      return this.toHex([red, green, blue, alpha]);
    }
  }

  private toHex(values: number[]): string {
    const hex = values
      .map((value) => {
        const hexString = value.toString(16);
        return hexString.length % 2 ? `0${hexString}` : hexString;
      })
      .join('');

    return `#${hex}`;
  }
}
